// extracted by mini-css-extract-plugin
module.exports = {"header":"app_header__pUyCJ","img":"app_img__1WsDU"};